import { differenceInMonths, parseISO } from 'date-fns';

const isMoreThenAMonthAgo = (dateString: string): boolean => differenceInMonths(new Date(), parseISO(dateString)) > 1;

export default isMoreThenAMonthAgo;
